import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Download } from "react-feather";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import "../styles/components/UserManual.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const UserManual = () => {
  const navigate = useNavigate();
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(840);
  const viewerWrapperRef = useRef(null);
  const manualUrl = `${process.env.PUBLIC_URL}/user-manual.pdf`;

  useEffect(() => {
    const updatePageWidth = () => {
      if (!viewerWrapperRef.current) return;
      const isMobile = window.innerWidth <= 768;
      // Phones render the page ~2x wider than the screen so the text is readable (pans sideways)
      const available = viewerWrapperRef.current.clientWidth - (isMobile ? 2 : 36);
      const nextWidth = isMobile
        ? Math.max(720, Math.floor(available * 2))
        : Math.max(280, Math.floor(available));
      setPageWidth(nextWidth);
    };

    updatePageWidth();
    window.addEventListener("resize", updatePageWidth);

    let observer;
    if (typeof ResizeObserver !== "undefined" && viewerWrapperRef.current) {
      observer = new ResizeObserver(updatePageWidth);
      observer.observe(viewerWrapperRef.current);
    }

    return () => {
      window.removeEventListener("resize", updatePageWidth);
      if (observer) observer.disconnect();
    };
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleDocumentLoad = ({ numPages: loadedPages }) => {
    setNumPages(loadedPages);
  };

  return (
    <div className="um-page">
      <div className="um-card">
        <div className="um-header">
          <button className="um-back-btn" onClick={handleBackButtonClick}>
            <ArrowLeft size={20} />
          </button>
          <div className="um-title-block">
            <h2 className="um-title">User Manual</h2>
            <p className="um-subtitle">Complete guide to the system</p>
          </div>
        </div>

        <div className="um-content">
          <div className="um-actions">
            <a
              href={manualUrl}
              className="um-download-btn"
              download="BERMER_User_Manual.pdf"
            >
              <Download size={16} />
              Download PDF
            </a>
          </div>

          <div className="um-viewer-wrapper" ref={viewerWrapperRef}>
            <Document
              file={manualUrl}
              onLoadSuccess={handleDocumentLoad}
              className="um-document"
              loading={<p className="um-status">Loading manual...</p>}
              error={<p className="um-status">Failed to load PDF.</p>}
            >
              {numPages
                ? Array.from({ length: numPages }, (_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      width={pageWidth}
                      className="um-page-item"
                    />
                  ))
                : null}
            </Document>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManual;
